import {
    getObjects,
    createObjects,
    updateObjects,
    deleteObjects,
    sendInvitationEmail as sendInvitationEmailAPI,
} from './../api/webApplicationApi';

const objectType = 'invitation';

export class Invitation {
    private _saveMethod = createObjects;
    private _object: omInvitation;
    private _lastError: Error;

    public constructor(email: string) {
        this._object = {
            invitationID: email,
            organizationID: undefined,
            accountID: undefined,
            userID: undefined,
            invitationDate: undefined,
            fromUserID: undefined,
        };
    }

    public static createFromObject(invitation: omInvitation): Invitation {
        const obj = new Invitation(invitation.invitationID);
        obj._object = invitation;
        obj._saveMethod = updateObjects;
        return obj;
    }

    public async load(): Promise<boolean> {
        const getObject: GetRequest = {
            objectType: objectType,
            keys: [this._object.invitationID],
        };
        this._lastError = undefined;
        try {
            const response = await getObjects([getObject]);
            if (
                response &&
                response.length > 0 &&
                response[0].objects &&
                response[0].objects.length == 1
            ) {
                this._saveMethod = updateObjects;
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('invitation not found');
                return false;
            }
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public async save(): Promise<boolean> {
        const saveObject: CreateUpdateDeleteRequest = {
            objectType: objectType,
            object: this._object,
        };
        this._lastError = undefined;

        if (this._object.fromUserID == undefined) {
            this._lastError = new Error('From User ID is undefined');
            return false;
        }

        if (this._object.organizationID == undefined) {
            this._lastError = new Error('Organization ID is undefined');
            return false;
        }

        if (this._object.invitationDate == undefined) {
            this._lastError = new Error('Invitation Date is undefined');
            return false;
        }

        if (this._object.accountID == undefined) {
            this._lastError = new Error('Account ID Date is undefined');
            return false;
        }

        if (this._object.userID == undefined) {
            this._lastError = new Error('User ID is undefined');
            return false;
        }

        try {
            const response = await this._saveMethod([saveObject]);
            if (response) {
                this._saveMethod = updateObjects;
            } else {
                this._lastError = new Error('unknow server error');
            }
            return response;
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public async delete(): Promise<boolean> {
        const deleteObject: CreateUpdateDeleteRequest = {
            objectType: objectType,
            object: this._object,
        };
        this._lastError = undefined;
        try {
            const response = await deleteObjects([deleteObject]);
            return response;
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    public async sendInvitationEmail(): Promise<boolean> {
        // has to save first so the backend can retreive the Invitation object
        if (this._saveMethod == createObjects) {
            return false;
        }

        const sendInvitationEmailRequest: SendInvitationEmailRequest = {
            invitationID: this.invitationID,
        };
        const response = await sendInvitationEmailAPI(
            sendInvitationEmailRequest
        );
        return response;
    }

    public get lastError(): Error {
        return this._lastError;
    }

    public get invitationID(): string {
        return this._object.invitationID;
    }

    public get accountID(): string {
        return this._object.accountID;
    }

    public set accountID(accountID: string) {
        this._object.accountID = accountID;
    }

    public get organizationID(): string {
        return this._object.organizationID;
    }

    public set organizationID(organizationID: string) {
        this._object.organizationID = organizationID;
    }

    public get fromUserID(): string {
        return this._object.fromUserID;
    }

    public set fromUserID(fromUserID: string) {
        this._object.fromUserID = fromUserID;
    }

    public get invitationDate(): Date {
        return this._object.invitationDate;
    }

    public set invitationDate(invitationDate: Date) {
        this._object.invitationDate = invitationDate;
    }

    public get userID(): string {
        return this._object.userID;
    }

    public set userID(userID: string) {
        this._object.userID = userID;
    }
}
